export default {
  INVESTOR_PROFILE_ON_RETIREMENT_BUDGET_REPOSITORY: Symbol.for('INVESTOR_PROFILE_ON_RETIREMENT_BUDGET_REPOSITORY'),
  UPDATE_INVESTOR_PROFILE_ON_RETIREMENT_BUDGET_COMMAND: Symbol.for('UPDATE_INVESTOR_PROFILE_ON_RETIREMENT_BUDGET_COMMAND'),
};
